import { useState, useEffect } from 'react';

const useOtpTimer = (initialTime = 30) => {
  const [timeLeft, setTimeLeft] = useState(initialTime);
  const [isRunning, setIsRunning] = useState(true); // Start running on mount

  useEffect(() => {
    let timer;
    if (isRunning && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setIsRunning(false); // Stop the timer when it reaches 0
    }

    return () => clearInterval(timer); // Cleanup on unmount
  }, [isRunning, timeLeft]);

  const resetTimer = () => {
    setTimeLeft(initialTime);
    setIsRunning(true);
  };

  const formattedTime = `${String(Math.floor(timeLeft / 60)).padStart(2, '0')}:${String(timeLeft % 60).padStart(2, '0')}`;

  return { 
    timeLeft, formattedTime, resetTimer, isRunning 
};
};

export default useOtpTimer;
